import { render, staticRenderFns } from "./VPSFFOtpValidateComponent.vue?vue&type=template&id=1b21dfee&scoped=true"
import script from "./VPSFFOtpValidateComponent.vue?vue&type=script&lang=js"
export * from "./VPSFFOtpValidateComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSFFOtpValidateComponent.vue?vue&type=style&index=0&id=1b21dfee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21dfee",
  null
  
)

export default component.exports